<template>
  <div id="app">
    <div v-if="status !== unknownStatus">
      <router-view />
    </div>
    <global-style />
  </div>
</template>

<script>
import GlobalStyle from '@/components/GlobalStyle'
import { STORAGE_KEYS, USER_ACTION } from '@/constants/storage'
import { clearStorageKeys, invalidateStorage } from '@/utils/storageUtils'
import { clearPageVisitHistory } from '@/history'
import { USER_STATUS } from '@/store/store'

function clearLogoutStates() {
  clearPageVisitHistory()
  invalidateStorage(STORAGE_KEYS.sidebar._key, USER_ACTION.LOGOUT)
  clearStorageKeys([STORAGE_KEYS.userContent])
}

export default {
  name: 'App',
  components: { GlobalStyle },
  data() {
    return {
      unknownStatus: USER_STATUS.UNKNOWN
    }
  },
  computed: {
    status() {
      return this.$store.getters.status
    }
  },
  async created() {
    try {
      const searchParams = new URL(window.location).searchParams
      const isUserCreated = !!searchParams.get('isUserCreated')
      await this.$store.dispatch('getCurrentUserWithCreationFlag', {
        created: isUserCreated
      })
    } catch {
      // do nothing
    }
  },
  watch: {
    async status(value) {
      if (value == USER_STATUS.NOT_LOGGED_IN) {
        clearLogoutStates()
        this.$router.onReady(() => {
          const route = this.$route
          const isPublic = route.matched.some(record => record.meta.public)
          if (!isPublic) {
            const noLoginRedirect = route.matched.some(record => record.meta.noLoginRedirect)
            this.$router.replace({
              name: 'login',
              query: {
                redirect: noLoginRedirect ? '/' : route.fullPath
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/all';
@import '~@/styles/base';
@import '~@/styles/icons/icons';

.dropdown-toggle.dropdown-toggle-no-caret::after {
  display: none !important;
}
</style>
